import Rollbar from 'rollbar'; // When using Typescript < 3.6.0.
// `import Rollbar from 'rollbar';` is the required syntax for Typescript 3.6.x.
// However, it will only work when setting either `allowSyntheticDefaultImports`
// or `esModuleInterop` in your Typescript options.

import {
  Injectable,
  InjectionToken,
  ErrorHandler,
  Inject
} from '@angular/core';
import { environment } from '../../environments/environment';
import { CustomError } from '../models/custom-error';

export const rollbarConfig = {
  enabled: !location.host.includes('localhost'),
  accessToken: 'ba3c8df52f594685816de280220f14b8',
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureIp: false,
  environment: environment.production ? 'production' : 'development',
};
@Injectable({
  providedIn: 'root'
})

export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar) { }

  handleError(err: CustomError): void {
    if (environment.production) {
      this.rollbar.error(err.originalError || err);
    } else {
      console.error(err.originalError || err);
    }
  }
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}

export const RollbarService = new InjectionToken<Rollbar>('rollbar');
export const RollbarConfigInjector = new InjectionToken<Rollbar.Configuration>('rollbarConfig');

